import { Button } from "@/components/ui/button";
import handlePrint from "@/utils/handlePrint";
import { PrinterIcon, Loader2 } from "lucide-react";
import QuotationPdf from "./QuotationPdf";
import { Quotation } from "@/v2/types";
import { useState } from "react";
import PrintAddressDialog from "../../print/common/AddressDialog";
import { Branches } from "@/v2/constants";

export default function PrintQuotation({
    data,
    isInside = false,
}: {
    data: Quotation;
    isInside?: boolean;
}) {
    const [isPrinting, setIsPrinting] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [branch, setBranch] = useState<Branches>("YANBU");

    const onConfirmPrint = async () => {
        try {
            setIsPrinting(true);
            setDialogOpen(false);
            await handlePrint(
                <QuotationPdf data={data} addressBranch={branch} />,
                {
                    fileName: data.quotation_number,
                },
            );
        } catch (err) {
            console.error("Print failed", err);
        } finally {
            setIsPrinting(false);
        }
    };

    return (
        <>
            <Button
                size="sm"
                variant={isInside ? "default" : "outline"}
                onClick={() => setDialogOpen(true)}
                disabled={isPrinting}
            >
                {isPrinting ? (
                    <>
                        <Loader2 className="m-0 h-4 w-4 animate-spin" />
                        {isInside && <span className="ml-2">Generating…</span>}
                    </>
                ) : (
                    <>
                        <PrinterIcon className="m-0 h-4 w-4" />
                        {isInside && <span className="ml-2">Print</span>}
                    </>
                )}
            </Button>

            <PrintAddressDialog
                open={dialogOpen}
                setOpen={setDialogOpen}
                branch={branch}
                setBranch={setBranch}
                onConfirmPrint={onConfirmPrint}
            />
        </>
    );
}
